import * as React from 'react';

import {
  INewbuildingsCompareActionRow,
  INewbuildingsCompareBlockRow,
  INewbuildingsCompareDataRow,
  TNewbuildingsCompareViewRow,
} from '../../NewbuildingsComparePage';

/** Блок сравнения = отдельная карточка-остров: заголовок блока и все его строки. */
export interface INewbuildingsCompareCard {
  key: string;
  header?: INewbuildingsCompareBlockRow;
  rows: (INewbuildingsCompareActionRow | INewbuildingsCompareDataRow)[];
}

/**
 * Плоский список строк (он же у десктопа) разбираем на карточки: строка kind: 'block' открывает
 * новую карточку, следующие за ней строки складываются в неё. Строки до первого заголовка блока
 * попадают в карточку без заголовка.
 */
export function useCompareCards(rows: TNewbuildingsCompareViewRow[]): INewbuildingsCompareCard[] {
  return React.useMemo(() => {
    const result: INewbuildingsCompareCard[] = [];

    rows.forEach(row => {
      if (row.kind === 'block') {
        result.push({ header: row, key: row.key, rows: [] });

        return;
      }

      if (result.length === 0) {
        result.push({ key: 'block-untitled', rows: [] });
      }

      result[result.length - 1].rows.push(row);
    });

    return result;
  }, [rows]);
}
